import React from "react";
import Content from "src/pages/community/Content";
import Community from "src/pages/community/Community";
import ShowPosts from "src/pages/community/Posts/Show";
import Users from "src/pages/community/Users";
import ShowUser from "src/pages/community/Users/Show";
import Assets from "src/pages/community/Assets";
import ShowAsset from "src/pages/community/Assets/Show";
import Reports from "src/pages/community/Reports";
import Bundles from "src/pages/community/Bundles";
import ShowBundle from "src/pages/community/Bundles/Show";
import AppShow from "src/pages/community/Apps/Show";
import Apps from "src/pages/community/Apps";

const communityRoutes = [
  { path: '/apps', element: <Apps /> },

  { path: '/community/:app_id/content',     element: <Content /> },
  { path: '/community/:app_id/community',   element: <Community /> },

  { path: '/community/:app_id/assets',      element: <Assets /> },
  { path: '/community/:app_id/assets/:id',  element: <ShowAsset /> },

  { path: '/community/:app_id/posts/:id',   element: <ShowPosts /> },

  { path: '/community/:app_id/users',       element: <Users /> },
  { path: '/community/:app_id/users/:id',   element: <ShowUser /> },

  { path: '/community/:app_id/bundles',       element: <Bundles /> },
  { path: '/community/:app_id/bundles/:id',   element: <ShowBundle /> },

  { path: '/community/:app_id/reports', element: <Reports /> },
  { path: '/community/:app_id/settings', element: <AppShow /> },
]

export default communityRoutes;
